import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import { grey } from '@mui/material/colors'
import Typography from '@mui/material/Typography'
import React from 'react'

import { WEEK_DAYS } from 'settings/constants/day'
import { parseBeDaysOfWeek } from 'types/adapters/route/deriveRecurrence'

type ReactivationServiceDaysProps = {
  daysOfWeek?: string | null
}

// The search row abbreviates the service's recurring days the way the route rows do (UMTWRFS).
const ReactivationServiceDays = ({ daysOfWeek }: ReactivationServiceDaysProps) => {
  const scheduled = new Set<string>(parseBeDaysOfWeek(daysOfWeek))

  return (
    <Box display="flex" gap={2}>
      {WEEK_DAYS.map(day => {
        const isScheduled = scheduled.has(day.toLowerCase())
        return (
          <Avatar
            key={day}
            aria-label={isScheduled ? `${day} scheduled` : day}
            sx={{
              width: 24,
              height: 24,
              bgcolor: isScheduled ? 'primary.main' : grey[100],
              border: '1px solid',
              borderColor: isScheduled ? 'primary.main' : 'divider',
            }}
          >
            <Typography color={isScheduled ? 'common.white' : 'text.secondary'} variant="subtitle2">
              {day.charAt(0)}
            </Typography>
          </Avatar>
        )
      })}
    </Box>
  )
}

export default ReactivationServiceDays
